/* eslint-disable function-paren-newline */
import { createSelector } from 'reselect';

export const networksSelector = (state) => state.networks;
export const userSelector = (state) => state.user;
export const pageSelector = (state) => state.page;
export const jobFunctionsSelector = (state) => state.jobFunctions;
export const activeCompanySelector = (state) => {
  if (state.companyProfile && state.companyProfile.company) {
    return state.companyProfile.company;
  }
  return null;
};

export const companyAdminSelector = createSelector(activeCompanySelector, (state) => {
  if (!state) {
    return [];
  }
  return state.managers || [];
});

export const activeNetworkSelector = createSelector(networksSelector, (networksStore) => {
  const { networks, active } = networksStore;
  if (networks === null || networks.length === 0 || !active) {
    return null;
  }

  return networks[active];
});

export const hasJobAlertsEnabledSelector = createSelector(activeNetworkSelector, ({ features }) => {
  if (!features) return false;

  return !features.includes('no_job_alerts');
});

export const hasSuggestedCompaniesSelector = createSelector(
  activeNetworkSelector,
  ({ supportsSuggestedCompanies, isManager }) => supportsSuggestedCompanies && isManager,
);

export const isActiveSyncSelector = createSelector(userSelector, (user) => {
  const { linkedinSync } = user || {};
  if (!linkedinSync) return false;

  return linkedinSync.syncStatus === 'active' && linkedinSync.contactsImportInProgress;
});

export const jobApplicantsJobTnSelector = createSelector(activeNetworkSelector, (network) => {
  if (!network) return false;

  const { features } = network;

  return features.includes('job_board') || network.isCompany;
});

export const isSourcingAgentSelector = createSelector(activeNetworkSelector, (network) => {
  if (!network) return false;

  const { features } = network;

  return features?.includes('sourcing_agent');
});
